import {
  CreateShopCategoryDto,
  ShopCategoryDto,
  PatchShopCategoryDto,
} from '@careapp-group/ng-sdk';
import { BaseFilterType, CaEntityActionsFactory } from '../entity-state/entity-actions-factory';

class MarketManagementCategoryActions extends CaEntityActionsFactory<
  ShopCategoryDto,
  CreateShopCategoryDto,
  PatchShopCategoryDto,
  BaseFilterType
> {
  constructor() {
    super(`MarketManagementCategories`);
  }
}

export const MarketManagementCategories = new MarketManagementCategoryActions();
